@if (rbList) {
<div class="right-block">
  <div class="widget-body">
    <div
      class="widget-toolbox"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <button mat-button (click)="onPreviousRulebook()">
        <mat-icon aria-hidden="true" aria-label="Next">arrow_back</mat-icon
        >Previous
      </button>
      <button mat-button class="reverse-icon-button" (click)="onNextRulebook()">
        Next<mat-icon aria-hidden="true" aria-label="Next"
          >arrow_forward</mat-icon
        >
      </button>
    </div>
    <div class="widget-main">
      @for (ac of rbList; track ac) {
      <ul class="nav-list">
        @if (ac.acronym !== 'Custom') { @for (tpc of ac.topics; track tpc) {
        <ul class="sub-menu" fxLayout="row" fxLayoutAlign="start start">
          <li class="sub-menu">
            <span class="heavy"
              >{{ ac.acronym }}&nbsp;>&nbsp;{{ tpc.topic }}</span
            >
            @for (rb of tpc.rulebooks; track rb) {
            <ul class="sub-item">
              <div
                fxLayout="row"
                [ngClass]="{ active: rb.appKey == this.selected }"
              >
                <span
                  fxFlex="75"
                  [ngClass]="{ disabled: rb.abridged == 1 }"
                  class="text-inside-list"
                  (click)="onClickRulebook(rb.appKey, rb.rbName, rb.abridged)"
                >
                  {{ rb.rbName }}@if (rb.abridged) {
                  <mat-icon matTooltip="Abridged Protocol">info</mat-icon>
                  }
                </span>
                <span fxFlex="25" class="percentage">
                  @if (rb.checkNa == false) {
                  <span
                    class="rb-percent"
                    [ngClass]="{ complete: rb.percentage == '100%' }"
                    >{{ rb.percentage }}
                  </span>
                  } @if (rb.checkNa == true) {
                  <span class="rb-checkNa">N/A</span>
                  }&nbsp; @if (rb.appKey == this.selected) {
                  <mat-icon aria-hidden="true" aria-label="Next" class="active"
                    >grade</mat-icon
                  >
                  }
                </span>
              </div>
            </ul>
            }
          </li>
        </ul>
        } }
      </ul>
      }
    </div>
    <div
      class="widget-toolbox bottom"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <button mat-button (click)="onPreviousRulebook()">
        <mat-icon aria-hidden="true" aria-label="Next">arrow_back</mat-icon
        >Previous
      </button>
      <button mat-button class="reverse-icon-button" (click)="onNextRulebook()">
        Next<mat-icon aria-hidden="true" aria-label="Next"
          >arrow_forward</mat-icon
        >
      </button>
    </div>
  </div>
</div>
} @else { No Data Available }
